import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import { composeEnhancers } from './utils';
import { querySyncEnhancer } from '../querySync/querySyncConfig';

const middleware = [thunk];

const enhancer = composeEnhancers(
    applyMiddleware(...middleware),
    querySyncEnhancer,
);

const initialState = {};

const store = createStore(rootReducer(), initialState, enhancer);

export default store;
